<template>
  <div class="hvh-flex column overflow-hidden" style="padding: 5px 0px 5px 5px; line-height: 20px">
    <DPDPill :label="getValueLabel(node)" :type="type" @mousedown.stop.prevent="$emit('mousedown', $event)" />
  </div>
</template>

<script>
import { getEventValueLabel } from '../../../libraries/criteria';
import DPDPill from '../../analytics/cohorts/DPDPill.vue';
export default {
  noExport: true,
  components: { DPDPill },
  props: ['eventHashMap', 'node', 'errorClass'],
  data() {
    return {
      classes: Array.from(document.styleSheets)
        .flatMap(f => Array.from(f.rules))
        .filter(f => (f.selectorText || '').indexOf('.vue-treeselect_item') > -1)
    }
  },
  computed: {
    item() {
      return this.eventHashMap[this.node.id];
    },
    type() {
      return ((this.item || {}).type || '').toLowerCase();
    },
  },
  methods: {
    getClass(node) {
      var event = this.eventHashMap[node.id]

      if (event && event.type)
        return 'vue-treeselect_item-' + event.type.toLowerCase();
      else if (node?.children?.length) {
        var grouped = node.children
          .filter(t => t['id'] !== 'topProcLabel' && t['id'] !== 'topDiagLabel')
          .map(f => this.classes.find(g => g.selectorText.indexOf(this.getClass(f)) > -1))
          .unique(f => `${f.style.backgroundColor}-${f.style.color}`);
        if (grouped.length === 1)
          return this.getClass(node.children[0]);
      }
    },
    setParentClass() {
      var addClass = this.getClass(this.node);
      var parent = this.$el.parentNode.parentNode;
      // @ts-ignore
      Array.from(parent.classList)
        // @ts-ignore
        .filter(f => f.startsWith('vue-treeselect_item-'))
        .forEach(f => parent.classList.remove(f));

      if (addClass)
        parent.classList.add(addClass, true);
    },
    getValueLabel(node) {
      // For root branches, we want to append the search query so they are less vague. Example: Drugs ("aspirin")
      if (node.raw.query) {
        return node.label + ' ("' + node.raw.query + '")';
      }

      if (!this.eventHashMap[node.id]) {
        return node.label;
      }
      return getEventValueLabel(this.eventHashMap[node.id]);
    },
  },
  mounted() {
    this.setParentClass();
  },
  updated() {
    this.setParentClass();
  },
}
</script>

<style lang="scss" scoped>
.tree-select-item {
  display: inline-block;
  line-height: 30px;
}
</style>